import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Table, Button } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { handleSetPost, handleGetPostList } from '../actions/api';
import recruitColumns from '../data/columns/recruitColumns';
import { CATEGORY_RECRUIT } from '../data/constants';
import Writing from '../components/Writing';
import PageTitle from '../components/PageTitle';
import Spinner from '../components/Spinner';

const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 10px;
	button {
		width: 100px;
		height: 36px;
	}
`;

const Recruitment = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [showWriteModal, setShowWriteModal] = useState(false);
	const [language, setLanguage] = useState('KR');
	const [list, setList] = useState([]);
	const history = useHistory();
	const dispatch = useDispatch();

	const handleLoadDetail = (data) => {
		console.log(data);
		history.replace(`/recruit/${language.toLocaleLowerCase()}/${data.SK}`);
	};

	// 글쓰기/ 수정하기
	const handleFinish = async (value) => {
		dispatch({
			type: 'IS_LOADING',
			payload: true,
		});
		const sent = await handleSetPost('setRecruit', { ...value, language });
		if (sent) {
			dispatch({
				type: 'IS_LOADING',
				payload: false,
			});
		}
	};
	//  삭제
	const handleDeleteRow = async (data) => {
		dispatch({
			type: 'IS_LOADING',
			payload: true,
		});
		const sentDelete = await handleSetPost('setRecruit', {
			...data,
			language,
			delete: 'true',
		});
		if (sentDelete) {
			dispatch({
				type: 'IS_LOADING',
				payload: false,
			});
		}
	};

	const { lang, id } = useParams();
	useEffect(() => {
		setIsLoading(true);
		setLanguage(lang.toUpperCase());

		// 목록 state list
		(async () => {
			await handleGetPostList(
				'getRecruitList',
				'recruit',
				null,
				lang.toUpperCase(),
				setList
			);
			setIsLoading(false);
		})();
	}, [lang, id]);

	return (
		<>
			{isLoading && <Spinner />}
			<PageTitle text='RECRUITMENT BOARD' />
			<ButtonContainer>
				<Button type='primary' onClick={() => setShowWriteModal(true)}>
					글쓰기
				</Button>
			</ButtonContainer>
			<Table
				columns={recruitColumns(handleDeleteRow, handleLoadDetail)}
				dataSource={list}
			/>
			{showWriteModal && (
				<Writing
					category={CATEGORY_RECRUIT}
					visible={showWriteModal}
					onModalVisible={setShowWriteModal}
					onFinish={handleFinish}
				/>
			)}
		</>
	);
};

export default Recruitment;
